// extracted by mini-css-extract-plugin
module.exports = {"factBox":"FactBox_factBox__AN7Th"};